import { render, staticRenderFns } from "./LoaderContent.vue?vue&type=template&id=d5e08378&"
import script from "./LoaderContent.vue?vue&type=script&lang=js&"
export * from "./LoaderContent.vue?vue&type=script&lang=js&"
import style0 from "./LoaderContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports